import { useEffect, useRef } from "react";
import { useRecoilState } from "recoil";
import { useCourtAuth } from "src/components/court-auth";
import { agreementCheckResultState } from "src/recoil/auth/atom";
import tokenResponseRepository from "src/components/court-auth/utils/token-response-repository";
import { useConsentAgreements } from "./useConsentAgreements";

/**
 * 인증 완료(ROLE_MEMBER) 시점에 미동의 약관을 1회 조회해 agreementCheckResultState을 결정하는 훅.
 */
export const useAgreementCheckInit = () => {
  const { security } = useCourtAuth();
  const { fetchUngrantedAgreements } = useConsentAgreements();
  const [result, setResult] = useRecoilState(agreementCheckResultState);
  // 동일 회원에 대한 동시 중복 조회 방지
  const inFlightRef = useRef<string | null>(null);

  useEffect(() => {
    if (security.status !== "authenticated") return;
    const memberNo = security.user?.memberNo;
    if (!memberNo) return;
    // 가입 미완료(ROLE_STARTER)는 약관 체크 대상 아님
    if (security.user?.roles.includes("ROLE_STARTER")) return;
    // 현재 회원 이미 조회함 -> 재조회하지 않음
    if (result?.memberNo === memberNo) return;
    if (inFlightRef.current === memberNo) return;
    inFlightRef.current = memberNo;

    (async () => {
      try {
        const agreements = await fetchUngrantedAgreements();
        const required = agreements.length > 0;
        setResult({ memberNo, required });
        // 약관 불필요(또는 이미 동의)면 메모리 토큰을 영속화한다 (기존 회원의 신규 로그인 케이스)
        if (!required) tokenResponseRepository.commit();
      } catch (error) {
        console.error("useAgreementCheckInit error", error);
        setResult({ memberNo, required: false }); // fail-open
        tokenResponseRepository.commit();
      } finally {
        inFlightRef.current = null;
      }
    })();
  }, [security, result, fetchUngrantedAgreements, setResult]);
};
